export const environment = {
	production: true,
	name: 'admin-ui',
	app: 'admin',
	env: undefined,
	version: undefined,
	fcKey: undefined,
	endpoints: undefined,
	websocket: undefined,
	analytics: undefined,
  features: {
    reporting: undefined
  }
};
